import { useState, useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';

// TODO: upgrade to edge header country code when available
const US_TIMEZONES = [
  'America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles',
  'America/Anchorage', 'Pacific/Honolulu', 'America/Phoenix', 'America/Detroit',
  'America/Indiana', 'America/Kentucky', 'America/Boise', 'America/Juneau',
  'America/Adak', 'America/Nome', 'America/Sitka', 'America/Yakutat',
  'America/Menominee', 'America/North_Dakota',
  'US/Eastern', 'US/Central', 'US/Mountain', 'US/Pacific', 'US/Alaska', 'US/Hawaii',
];

function isLikelyUS(): boolean {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return US_TIMEZONES.some(usTz => tz.startsWith(usTz));
  } catch {
    return true; // Fail open — don't block on detection failure
  }
}

const DISMISS_KEY = 'optibay_us_notice_dismissed';

export function USOnlyNotice() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(DISMISS_KEY)) return;
    if (!isLikelyUS()) setShow(true);
  }, []);

  if (!show) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, '1');
    setShow(false);
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-accent text-accent-foreground px-4 py-2.5 flex items-center justify-between gap-3 text-sm shadow-md border-b border-border">
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span>
          OptiBay is currently available for US-based shops only. If you believe this is an error, please contact support.
        </span>
      </div>
      <button onClick={handleDismiss} className="shrink-0 p-1 hover:bg-muted rounded" aria-label="Dismiss">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
